import Header from "@/components/Header";
import Hero from "@/components/Hero";
import StatsStrip from "@/components/StatsStrip";
import Marquee from "@/components/Marquee";
import PracticeChannels from "@/components/PracticeChannels";
import Experience from "@/components/Experience";
import Ethos from "@/components/Ethos";
import Academics from "@/components/Academics";
import Reviews from "@/components/Reviews";
import Blogs from "@/components/Blogs";
import ConnectBanner from "@/components/ConnectBanner";
import Footer from "@/components/Footer";
import FloatingWhatsApp from "@/components/FloatingWhatsApp";

const HomePage = () => (
  <>
    <Header />
    <main>
      <Hero />
      <StatsStrip />
      <Marquee />
      <PracticeChannels />
      <Experience />
      <Ethos />
      <Academics />
      <Reviews />
      <Blogs />
      <ConnectBanner />
    </main>
    <Footer />
    <FloatingWhatsApp />
  </>
);

export default HomePage;
